/* unplugin-vue-components disabled */import script from "./approval-transfer.vue?vue&type=script&setup=true&lang=js"
export * from "./approval-transfer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__